import { SelectionModel } from '@angular/cdk/collections';
import { AfterViewInit, Component, ElementRef, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { ModalDismissReasons, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { BehaviorSubject, debounceTime, distinctUntilChanged, fromEvent, takeUntil, tap } from 'rxjs';
import { Sale } from 'src/app/models/sales/sales.model';
import Swal from 'sweetalert2';

import { LookupModel } from '../models/common/lookup.model';
import { VetMemberAccountModel, VetMemberAccountTableFields } from '../models/vet-users/vet-member-account.model';
import { AuthService } from '../services/auth.service';
import { SalesService } from '../services/sales.service';
import { VetUsersService } from '../services/vet-users.service';
import { BaseUnsubscribeComponent } from '../shared-new/components/base-unsubscribe/base-unsubscribe.component';
import { Helper } from '../utils/helper/helper';
import { AccountManagementDataSource } from './account-management-datasource';

import { HttpErrorHandlerService } from '../services/http-error-handler.service';
import { Router } from '@angular/router';
import { SaleMemberAccessPopupComponent } from '../sales/sale-member-access-popup/sale-member-access-popup.component';
import { MatSort } from '@angular/material/sort';
import { SalesFacade } from '../shared-new/store/sales/sales.facade';
import { VetProfileNotificationDetailPopupComponent } from '../profile-page/vet-profile-notification-detail-popup/vet-profile-notification-detail-popup.component';

@Component({
  selector: 'app-account-management',
  templateUrl: './account-management.component.html',
  styleUrls: ['./account-management.component.scss'],
  providers: [Helper],
})
export class AccountManagementComponent
  extends BaseUnsubscribeComponent
  implements OnInit, OnDestroy, AfterViewInit
{
  public vetUsers: VetMemberAccountModel[] = null;
  public allVetUsers: VetMemberAccountModel[] = null;
  public isLoader: boolean;
  public selection = new SelectionModel<VetMemberAccountModel>(true, []);
  public selectedSale: LookupModel = {
    id: 0,
    name: '',
    altName: '',
    selected: false
  };
  public saleLooup: LookupModel[] = null;
  public dataSource: AccountManagementDataSource;
  @ViewChild(MatSort) sort: MatSort;
  public displayedColumns$ = new BehaviorSubject([
    // 'checkbox',
    'vetName',
    'memberName',
    'phoneNumber',
    'emailAddress',
    'organisationID',
    'accreditationNumber',
    'saleName',
    'saleAccess',
    'action',
  ]);
  public closeResult = '';
  public checkboxSelectedIds: number[];
  public checkedAll = false;
  public vetMemberAccountTableFields = VetMemberAccountTableFields;

  public searchTerm: string;
 /* @ViewChild('searchInput') public readonly searchInput: ElementRef;*/

  constructor(
    private readonly vetUsersService: VetUsersService,
    private readonly helper: Helper,
    private readonly saleService: SalesService,
    private readonly modalService: NgbModal,
    private readonly authService: AuthService,
    private readonly salesFacade: SalesFacade,
    private readonly httpErrorHandleService: HttpErrorHandlerService,
    private readonly router: Router
  ) {
    super();
  }

  public loadVetUsers(): void {
    this.isLoader = true;
    this.vetUsersService
      .getVetMemberAccounts(this.selectedSale.id)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        if (response) {
          this.vetUsers = response;

          this.vetUsers = this.vetUsers.map((obj) => {
            obj.checkbox = false;
            return obj;
          });

          this.allVetUsers = this.helper.deepCopy(this.vetUsers);
          this.dataSource = new AccountManagementDataSource(
            this.vetUsers,
            this.sort
          );

          this.sort.active = 'vetName';
          this.sort.direction = 'asc';
          this.dataSource.sort = this.sort;
          this.sort.sortChange.emit(); // triggers sorting and shows arrow
          this.isLoader = false;
          if (this.searchTerm) {
            this.dataSource.searchTable(this.searchTerm);
          }
         
        }
      });
  }
  public IsSalesComapny(): boolean {
   return this.authService.IsSalesCompany();
  }
  public ResetPassword(user: any): void {
    Swal.fire({
      title: 'Send Reset Password',
      text: 'Do you want to Reset the Password?',
      showCancelButton: true,
      cancelButtonText: 'Cancel',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Resest',
      confirmButtonColor: '#1b6da6',
    }).then((result) => {
      if (result.value) {
        user.loading = true;
        this.authService.forgotPasswordByUserId(user.userId).subscribe(
          (response) => {
            if (response) {
              Swal.fire(
                'Success',
                "We've sent an email to the address associated with this user.",
                'success'
              );
            }

            user.loading = false;
          },

          (err) => {
            user.loading = false;
            if (err) {
              this.httpErrorHandleService.ShowErrorMessage(err);
            }
          }
        );
      }
    });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  //public onChangeCheckboxes(
  //  isChecked: boolean,
  //  key: 'SINGLE' | 'ALL',
  //  vetMemberAccount: VetMemberAccountModel = null,
  //  index: number = -1
  //): void {
  //  if (key === 'ALL') {
  //    this.dataSource.onClickAllCheckbox(isChecked);
  //  } else {
  //    this.dataSource.onClickSingleCheckbox(
  //      vetMemberAccount.memberId,
  //      isChecked
  //    );
  //  }

  //  if (index >= 0) {
  //    this.dataSource.onClickSingleCheckbox(vetMemberAccount.memberId, true);
  //  }

  //  const checkedRows = this.dataSource.getCheckedSelectedRows();

  //  if (checkedRows.length) {
  //    this.checkboxSelectedIds = checkedRows.map((data) => data.memberId);
  //  } else {
  //    this.checkboxSelectedIds = [];
  //  }
  //}

  public ngOnInit(): void {
    this.loadVetUsers();
    this.loadSaleLookup();
  }

 

  public loadSaleLookup(): void {
    this.saleService
      .getSaleLookup()
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe((response) => {
        this.saleLooup = [{ id: 0, name: 'All',altName:'',selected:false }].concat(response);
      });
  }

  vetProfileDetail(vet: VetMemberAccountModel): void {

    const modalRef = this.modalService.open(VetProfileNotificationDetailPopupComponent, {
      size: '50-width',
      keyboard: false,
      backdrop: 'static',
    });
    modalRef.componentInstance.data = { userId: vet.userId, memberId: vet.memberId, Name: vet.vetName };

    modalRef.result.then(
      (result) => {
        //this.activityEnd.emit(Activity.XRayView);
      },
      (reason) => {
        //this.activityEnd.emit(Activity.XRayView);
      }
    );
  }

  public navigateToMemberAccess(memberId: number, memberName: string) {
    const modalRef = this.modalService.open(SaleMemberAccessPopupComponent, {
      ariaLabelledBy: memberId + 'Id',
      size: 'lg',
      keyboard: false,
      backdrop: 'static',
    });
    this.salesFacade.clearSaleMemberAccess();
    modalRef.componentInstance.data = {
      memberId: memberId,
      memberName: memberName
    };
    modalRef.componentInstance.stickyTop = '4rem';
    modalRef.result.then(
      (result) => {
        const data = JSON.parse(result);
        const hasAllSale = (data.data as any[]).some(x => !x.saleId);
        if (hasAllSale) {
          const allSaleRow = (data.data as any[]).filter(x => !x.saleId)[0];
          const viewing = allSaleRow.isViewAccess ? 'Viewing' : '';
          const submitting = allSaleRow.isSubmitAccess ? 'Submitting' : '';
         // const status = allSaleRow.isViewAccess && allSaleRow.isSubmitAccess ? 'FULL' : allSaleRow.isViewAccess ? viewing.toUpperCase() : allSaleRow.isSubmitAccess ? submitting.toUpperCase() : 'INVITED'
          this.dataSource.updateVetAccount(data.memberId, viewing, submitting);
        } else {
          const saleRow = (data.data as any[]).filter(x => x.saleId == this.selectedSale.id);
          if (saleRow.length > 0) {
            const row = saleRow[0];
            const viewing = row.isViewAccess ? 'Viewing' : '';
            const submitting = row.isSubmitAccess ? 'Submitting' : '';
            //const status = row.isViewAccess && row.isSubmitAccess ? 'FULL' : row.isViewAccess ? viewing.toUpperCase() : row.isSubmitAccess ? submitting.toUpperCase() : 'INVITED'
            this.dataSource.updateVetAccount(data.memberId, viewing, submitting);
          }
        }
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  public onTableScroll(): void {
    this.dataSource.onScroll();
  }

  public ngAfterViewInit(): void {
    //fromEvent(this.searchInput.nativeElement, 'keyup')
    //  .pipe(
    //    debounceTime(50),
    //    distinctUntilChanged(),
    //    takeUntil(this.unsubscribe$),
    //    tap(() => {
    //      const term = this.searchInput.nativeElement.value;
    //      this.dataSource.searchTable(term);
    //    })
    //  )
    //  .subscribe();

    //if (this.searchTerm) {
    //  this.searchInput.nativeElement.value = this.searchTerm;
    //  this.dataSource.searchTable(this.searchTerm);
    //}
  }
  filterAccounts(searchText: string) {
    this.searchTerm = searchText;
    this.dataSource.searchTable(this.searchTerm);
  }
}
